/**
 * Styles for the Cosmetics settings section.
 */

.preview {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 4px 0 12px;
}

/* Positioning context and clip for the foil overlay, at card proportions. */
.card {
  position: relative;
  flex-shrink: 0;
  width: 92px;
  aspect-ratio: 63 / 88;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgb(0 0 0 / 45%);
}

.art {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.blurb {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #9ca3af;
}

.form {
  display: flex;
  gap: 8px;
  align-items: center;
}

.unlocked {
  font-size: 13px;
  font-weight: 600;
  color: #4ade80;
  white-space: nowrap;
}

.failure {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #f87171;
}

@media (max-width: 520px) {
  .preview {
    flex-direction: column;
    align-items: flex-start;
  }
}
